<template>
  <div class="pages">
    <van-loading type="spinner" />
  </div>
</template>

<script>
import { Loading } from 'vant';
export default {
  components:{
    [Loading.name]: Loading
  },
  mounted(){
      if(window.history.length > 1) window.uni.reLaunch({url:'/pages/tabbar/my/index'});
      else {
        let { baseURL , token , successUrl , failedUrl } = this.$route.query;
        window.location.href = `${baseURL}?token=${token}&successUrl=${encodeURIComponent(successUrl)}&failedUrl=${encodeURIComponent(failedUrl)}`
      }
  },
  updated(){
  },
}
</script>

<style scoped lang="scss">
  .pages {
    height: 100vh;
    background: #f0f1f2;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>